import axios, {AxiosResponse} from "axios";
import AppEventBus from "./AppEventBus";
import DataFilters from "./DataFilters";
import Helper from "./Helper";
import {createApp} from 'vue';

import Button from 'primevue/button';
import TabView from "primevue/tabview";
import TabPanel from "primevue/tabpanel";
import Message from "primevue/message";
import ProgressBar from "primevue/progressbar";
import IModalProgress from "../components/CommonIndependent/IModalProgress.vue";
import Toolbar from "primevue/toolbar";
import Dropdown from "primevue/dropdown";
import Textarea from "primevue/textarea";
import InputText from "primevue/inputtext";
import MultiSelect from "primevue/multiselect";
import Skeleton from "primevue/skeleton";
import ConfirmDialog from "primevue/confirmdialog";
import Column from "primevue/column";
import InputNumber from "primevue/inputnumber";
import Checkbox from "primevue/checkbox";
import Paginator from "primevue/paginator";
import Calendar from "primevue/calendar";
import AccordionTab from "primevue/accordiontab";
import Accordion from "../components/ComponentsExtends/Accordion.vue";
import IModal from "../components/CommonIndependent/IModal.vue";
import Panel from "primevue/panel";
import Tag from "primevue/tag";
import InputMask from "primevue/inputmask";
import Fieldset from "primevue/fieldset";

export interface xShowModalProps {
    icon?: xConfirmPromptIcon | null,
    header?: string,
    text: string,
    overlay?: boolean,
    okBtnText?: string,
    cancelBtnText?: string,
    resolver?: () => void,
    showHideBtn?: boolean,
    showOkBtn?: boolean,
    showCancelBtn?: boolean,
}

export interface iModalProgressProps {
    severity: 'info',
    message: 'Загрузка...',
    showProgressBar: true,
    allowClose: false,
}

export interface xConfirmProps extends xShowModalProps {
    onSuccess?: () => any | void,
    onCancel?: () => any | void,
}

export interface xPromptProps extends xShowModalProps {
    defaultValue?: string | null,
    inputType: xInputType | null,
    inputPlaceholder?: string | null,
    onSuccess: (text: String) => any | void,
    onCancel?: () => any | void,
}

export type xInputType = 'input' | 'textarea'
export type xNotifyType = 'info' | 'success' | 'warn' | 'error';
export type xConfirmPromptIcon = 'error' | 'warning' | 'question';
export type xConfirmResultTypes = 'success' | 'cancel'

export interface xNotifyProps {
    type?: xNotifyType,
    header?: string,
    text: string,
    timeout?: number,
}

let version = undefined;

axios.interceptors.response.use(async response => {

    if ((new URL(window.location.href)).host !== (new URL(response?.request?.responseURL)).host)
        return response;

    if (version && response.headers['app-version'] !== version) {
        AppEventBus.emit('showBlockModal', ['Версия клиента и сервера отличаются. Приложение будет перезагружено через 5 секунд.', 'warn', true, false]);
        await Helper.methods.delay(5000);
        location.reload();
    }

    version = response.headers['app-version'];

    return response;
});

const def = {

    serverLimits: null,
    axios: axios,

    Instance: (options?: {
        props?: any;
        component: any,
        context?: any,
    }) => {

        const tempDiv = document.createElement('div');

        const app = createApp(options.component, options?.props)

        app.component('Button', Button);
        app.component('TabView', TabView);
        app.component('TabPanel', TabPanel);
        app.component('Message', Message);
        app.component('ProgressBar', ProgressBar);
        app.component('Toolbar', Toolbar);
        app.component('Dropdown', Dropdown);
        app.component('Textarea', Textarea);
        app.component('InputText', InputText);
        app.component('MultiSelect', MultiSelect);
        app.component('ConfirmDialog', ConfirmDialog);
        app.component('Column', Column);
        app.component('Skeleton', Skeleton);
        app.component('Checkbox', Checkbox);
        app.component('InputNumber', InputNumber);
        app.component('Paginator', Paginator);
        app.component('Calendar', Calendar);
        app.component('Accordion', Accordion);
        app.component('AccordionTab', AccordionTab);
        app.component('IModal', IModal);
        app.component('Panel', Panel);
        app.component('Tag', Tag);
        app.component('InputMask', InputMask);
        app.component('Fieldset', Fieldset);

        if (options?.context?._?.appContext?.config?.globalProperties)
            app.config.globalProperties = options.context._.appContext.config.globalProperties

        const instance = app.mount(tempDiv);

        /*for (const key in options.componentOptions)
            instance[key] = options.componentOptions[key]*/


        document.body.appendChild(tempDiv);

        return {
            app, instance
        }

    },

    createCookie(name, value, days) {
        let expires;

        if (days) {
            let date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        } else {
            expires = "";
        }
        document.cookie = encodeURIComponent(name) + "=" + encodeURIComponent(value) + expires + "; path=/";
    },

    post(url, post_data): Promise<AxiosResponse> {

        return new Promise((resolve, reject) => {

            axios.post(process.env.VUE_APP_API_URL + url,
                post_data,
                {
                    headers: {
                        //'Accept': 'application/json',
                        //'Session_id': store.state.session_id,
                    },
                    withCredentials: true,
                })
                .then(response => {

                    if (response?.headers?.['content-type'] !== 'application/json; charset=utf-8') {
                        console.log(response);
                        AppEventBus.emit('xShowModalError', {text: 'Сервер вернул неожиданный ответ'});
                        reject('Сервер вернул неожиданный ответ');
                    }


                    if (response.data.error) {
                        AppEventBus.emit('xShowModalError', {text: response.data.error})
                        reject(response.data.error);
                    }

                    resolve(response);
                })
                .catch(function (error) {
                    //console.log(error.response.status) // 401
                    if (error.response?.status === 401) {

                        AppEventBus.emit('changeRoute', '/login');
                    } else {
                        reject(error);
                    }

                });

        });

    },

    getFormDataSize(formData) {
        // eslint-disable-next-line no-unused-vars
        return [...formData].reduce((size, [name, value]) => size + (typeof value === 'string' ? value.length : value.size), 0)
    },

    async checkFormDataLimits(formData) {

        let $serverLimits;

        if (this.serverLimits) {
            $serverLimits = this.serverLimits;
        } else {
            try {
                await this.getServerLimits();
                $serverLimits = this.serverLimits;
            } catch (e) {
                console.error('С сервера не были получены данные о лимитах на загрузку файлов. Проверка пропущена.');
                console.error(e);
                return;
            }

        }

        let $error_text = [];
        let filesCount = 0;

        [...formData].forEach(([name, value]) => {

            if (value instanceof File) {
                filesCount++;
                if (value.size > $serverLimits['upload_max_filesize']) {

                    $error_text.push('Превышен лимит размера файла "' +
                        value.name + '". Размер файла: ' + DataFilters.methods.bytesToHumanPresent(value.size) + '. ' +
                        'Допустимый разммер одного файла: ' +
                        DataFilters.methods.bytesToHumanPresent($serverLimits['upload_max_filesize']) + '.');

                }
            }


        });

        if (filesCount > $serverLimits['max_file_uploads']) {

            $error_text.push('Превышен лимит количества файлов загружаемых на сервер. ' +
                'Количество загружаемых файлов: ' + filesCount + '. Допустимое количество: ' + $serverLimits['max_file_uploads']);

        }

        let formSize = this.getFormDataSize(formData);
        if (formSize > $serverLimits['post_max_size']) {

            $error_text.push('Превышен общий лимит загружаемых на сервер данных. ' +
                'Объем загружаемых данных: ' +
                DataFilters.methods.bytesToHumanPresent(formSize) +
                '. Допустимый объем: ' +
                DataFilters.methods.bytesToHumanPresent($serverLimits['post_max_size']));


        }

        if ($error_text.length)
            throw $error_text.join("<br>");

    },

    async getServerLimits() {

        console.log('Запрос лимитов загружаемых фалов на сервер');

        return await this.get('/common-actions/getServerLimits')
            .then((response) => {
                this.serverLimits = response.data.limits
                return response.data.limits;
            });

    },

    async postForm(url: string, Form: FormData): Promise<void | AxiosResponse> {

        await this.checkFormDataLimits(Form);

        return axios({
            method: "POST",
            url: process.env.VUE_APP_API_URL + url,
            data: Form,
            headers: {
                'Accept': 'application/json',
                //'Session_id': store.state.session_id,
                "Content-Type": "multipart/form-data"
            },
            withCredentials: true,
        })
            .then(function (response) {

                if (process.env.NODE_ENV === 'development')
                    console.log(response);

                if (response?.headers?.['content-type'] !== 'application/json; charset=utf-8') {
                    console.log(response);
                    AppEventBus.emit('xShowModalError', {text: 'Сервер вернул неожиданный ответ'});
                    throw new Error('Сервер вернул неожиданный ответ')
                }

                if (response.data.error) {
                    AppEventBus.emit('xShowModalError', {text: response.data.error})
                    throw response.data.error;
                }
                return response;
            })
            .catch(function (error) {

                console.log(error);

                if (!error)
                    return;

                if (error.response && error.response.status === 401) {
                    AppEventBus.emit('changeRoute', '/login');
                }

                throw error;

            });


    },

    async get(url: string): Promise<void | AxiosResponse> {

        return axios({
            method: "GET",
            data: null,
            url: process.env.VUE_APP_API_URL + url,
            headers: {
                //'Accept': 'application/json',
                "Content-Type": "'application/json"
            },
            withCredentials: true,
        })
            .then(function (response) {

                if (process.env.NODE_ENV === 'development')
                    console.log(response);

                if (response.data.error) {
                    AppEventBus.emit('xShowModalError', {text: response.data.error})
                    throw response.data.error;
                }
                return response;
            })
            .catch(function (error) {

                if (!error)
                    return;

                if (error.response && error.response.status === 401) {
                    AppEventBus.emit('changeRoute', '/login');
                }

                throw error;

            });


    },

    async getFileAsBinaryString(url: string, convertToBase64: boolean = false, suppressModalError: boolean = false) {

        const file = await this.getFile(url, suppressModalError)
        return await this.getBinaryStringFromFileObject(file.data, convertToBase64);

    },

    async getBinaryStringFromFileObject(file: File, convertToBase64: boolean = false) {

        const reader = new FileReader();
        reader.readAsBinaryString(file)
        return new Promise(resolve => {
            reader.onloadend = () => {
                resolve(convertToBase64 ? btoa((reader.result) as string) : reader.result);
            };
        });

    },

    async getFile(url: string, suppressModalError: boolean = false): Promise<void | AxiosResponse> {

        if (!url.startsWith('blob:'))
            url = process.env.VUE_APP_API_URL + url;

        return axios({
            method: "GET",
            url: url,
            /*headers: {
                //'Accept': 'application/json',
                'Session_id': store.state.session_id,
                //"Content-Type": "multipart/form-data"
            },*/
            responseType: 'blob',
            withCredentials: true,
        })
            .then(async function (response) {

                if (process.env.NODE_ENV === 'development')
                    console.log(response);

                if (response.data.type.indexOf('json') !== false) {

                    try {
                        response.data = JSON.parse(await (response.data).text());
                    } catch (e) {
                    }

                }

                if (response.data.error) {

                    if (!suppressModalError)
                        AppEventBus.emit('xShowModalError', {text: response.data.error})

                    throw new Error(response.data.error);

                }

                if (!response?.headers?.['content-disposition']) {
                    let err = 'Не удалось загрузить файл с сервера'
                    AppEventBus.emit('xShowModalError', {text: err})
                    throw new Error(err);
                }


                return response;
            })
            .catch(function (error) {

                if (!error)
                    return;

                if (error.response && error.response.status === 401) {
                    AppEventBus.emit('changeRoute', '/login');
                }

                throw error;

            });

    },

    async getFileAsFile(url: string, suppressModalError: boolean = false, form_data?: FormData): Promise<File> {

        try {
            if (!url.startsWith('blob:') && !url.startsWith('http'))
                url = process.env.VUE_APP_API_URL + url;

            let response = await axios({
                method: form_data ? "POST" : "GET",
                url: url,
                /*headers: {
                    //'Accept': 'application/json',
                    'Session_id': store.state.session_id,
                    //"Content-Type": "multipart/form-data"
                },*/
                responseType: 'blob',
                withCredentials: true,
                data: form_data,
            });

            if (process.env.NODE_ENV === 'development')
                console.log(response);

            if (response.data.type.indexOf('json') !== false) {

                try {
                    response.data = JSON.parse(await (response.data).text());
                } catch (e) {
                }

            }

            if (response.data.error) {

                if (!suppressModalError)
                    AppEventBus.emit('xShowModalError', {text: response.data.error})

                throw new Error(response.data.error);

            }

            if (!response?.headers?.['content-disposition']) {

                let err = 'Не удалось загрузить файл с сервера'

                if (!suppressModalError)
                    AppEventBus.emit('xShowModalError', {text: err})

                throw new Error(err);

            }

            let fileName = response.headers["content-disposition"].split("filename=")[1];
            let filenameUtf8 = (response as AxiosResponse).headers["filename-utf-8"];

            return new File([response.data], ((filenameUtf8) ? decodeURI(filenameUtf8) : fileName), {type: response.data.type})

        } catch (e) {

            if (!e)
                return;

            if (e.response && e.response.status === 401) {
                AppEventBus.emit('changeRoute', '/login');
            }

            throw e;

        }


    },

    xnotify($options: string | xNotifyProps) {
        AppEventBus.emit('xnotify', $options);
    },
    xerror($text: string) {
        AppEventBus.emit('xerror', $text);
    },
    xShowModal(options: xShowModalProps) {
        AppEventBus.emit('xShowModal', options);
    },
    xConfirm(options: xConfirmProps) {
        let resolver

        let P = new Promise<{
            result: xConfirmResultTypes,
            data?: string
        }>(resolve => resolver = resolve)
        AppEventBus.emit('xConfirm', {...options, resolver: resolver});
        return P
    },
    xPrompt(options: xPromptProps) {
        AppEventBus.emit('xPrompt', options);
    },
    xShowModalError(options: xShowModalProps | string) {
        AppEventBus.emit('xShowModalError', options);
    },
    showBlockModal($text, $severity = 'info', $showProgressBar = true, $allowClose = false) {
        AppEventBus.emit('showBlockModal', [$text, $severity, $showProgressBar, $allowClose]);
    },
    hideBlockModal() {
        AppEventBus.emit('hideBlockModal');
    },

    modalProgress: {

        show(options: iModalProgressProps | string) {

            if (typeof options === 'string')
                options = {
                    message: options
                } as iModalProgressProps

            const id = 'modal-progress'
            const el = document.querySelector('#' + id)?.parentElement

            if (!el) {

                const {app, instance} = def.Instance({
                    component: IModalProgress,
                });


                (instance as any).push(options)

            } else {

                const instance = (el as any)?.__vue_app__._instance
                instance.proxy.push(options)

            }

        },
        hide() {

            const id = 'modal-progress'
            const el = document.querySelector('#' + id)?.parentElement
            const instance = (el as any)?.__vue_app__?._instance
            if (!instance)
                return;

            instance.proxy.pop();

            if (instance.proxy.messages?.length === 0) {
                (el as any).__vue_app__.unmount()
                el.remove()
            }

        },


    },

    removeInstance(selector: string) {

        document.querySelectorAll(selector).forEach((item: any) => {

            const el = item?.__vue_app__?._instance ? item : item?.parentElement
            if (!el)
                return;

            /*const instance = (el as any)?.__vue_app__?._instance
            if (!instance)
                return;*/

            try {
                (el as any).__vue_app__?.unmount()
            } catch (e) {
                console.error(e);
            }

            el.remove()

        })


    }


}

export default def;